import React from "react";

import PublicConfig from "./PublicConfig";

function AppConatiner() {
    return (
        <PublicConfig />
    )
}
export default AppConatiner;